import { f as n } from "./export-cdcbfb2b.js";
var o = n, i = function(a, t) {
  var r = [][a];
  return !!r && o(function() {
    r.call(null, t || function() {
      return 1;
    }, 1);
  });
};
export {
  i as a
};
